// src/hooks/useUserPlan.ts
import { useUser } from "@clerk/clerk-react";
export type UserPlan = "free" | "pro";

// BASIS wird nicht mehr verkauft. Bestehende BASIS-Kunden (Clerk
// publicMetadata.plan === "basis") werden hier als Sicherheitsnetz dauerhaft
// zu "pro" normalisiert -- sie behalten vollen Zugriff, tauchen aber nirgends
// mehr als eigenes "BASIS"-Label auf, nur noch als "PRO".
export function useUserPlan(): { plan: UserPlan; isLoading: boolean } {
  const { user, isLoaded } = useUser();
  if (!isLoaded) {
    return { plan: "free", isLoading: true };
  }
  if (!user) {
    return { plan: "free", isLoading: false };
  }
  const publicMeta = (user.publicMetadata || {}) as Record<string, unknown>;
  const rawPlan =
    (publicMeta.plan as string | undefined) ??
    (publicMeta.subscriptionPlan as string | undefined);
  if (rawPlan === "pro" || rawPlan === "basis") return { plan: "pro", isLoading: false };
  return { plan: "free", isLoading: false };
}